import axios, { AxiosResponse } from 'axios';
import { SharedFolder } from 'views/file-sharing/types/shared-folder.type';

// This file contains endpoints that are used within the file sharing feature. If endpoints unrelated to file sharing are used within this feature, they should go into a shared /api/ folder within /src/

// /ewosapi/v1/file/{globalCompanyId}/${folderId}
export const getFolderById = async (globalCompanyId: string, folderId: string): Promise<SharedFolder> => {
  const res = await axios.get(`/ewosapi/v1/file/${globalCompanyId}/${folderId}`);
  return res.data;
};

// GET DOWNLOAD
//  /ewosapi/v1/useradmin/File/download/{fileId}
export const getDownloadFile = async (globalCompanyId: string, fileId: string): Promise<AxiosResponse> => {
  return await axios.get<AxiosResponse>(`/ewosapi/v1/file/${globalCompanyId}/download/${fileId}`, {
    responseType: 'blob',
  });
};
